/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetCardAccounts200,
  GetCardAccountsParams,
  CardAccount,
  CreateCardAccountBody,
  GetCardAccountTransactions200,
  GetCardAccountTransactionsParams,
  CardAccountTransaction,
  TransferCardAccountBody,
  TopupCardAccount400,
  TopupCardAccountBody,
  WithdrawCardAccount400,
  WithdrawCardAccountBody,
  SimulateRepayCardAccount200,
  SimulateRepayCardAccountBody,
  PostCardaccountsFixedLimitBody,
  PostCardaccountsClientIdentity200,
  PostCardaccountsClientIdentityBody,
  GetCardaccountsClientIdentity200,
  GetCardaccountsClientIdentityParams
} from './schema'



/**
 * Get a list of Card Accounts
 * @summary Get Card Accounts
 */
export const getCardAccounts = (
    params?: GetCardAccountsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetCardAccounts200>> => {
    return axios.get(
      `/cardaccounts`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetCardAccountsQueryKey = (params?: GetCardAccountsParams,) => [`/cardaccounts`, ...(params ? [params]: [])];

    
export type GetCardAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getCardAccounts>>>
export type GetCardAccountsQueryError = AxiosError<unknown>

export const useGetCardAccounts = <TData = Awaited<ReturnType<typeof getCardAccounts>>, TError = AxiosError<unknown>>(
 params?: GetCardAccountsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCardAccounts>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCardAccountsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCardAccounts>>> = ({ signal }) => getCardAccounts(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getCardAccounts>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Create a card account

 * @summary Create Card Account
 */
export const createCardAccount = (
    createCardAccountBody: CreateCardAccountBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CardAccount>> => {
    return axios.post(
      `/cardaccounts`,
      createCardAccountBody,options
    );
  }



    export type CreateCardAccountMutationResult = NonNullable<Awaited<ReturnType<typeof createCardAccount>>>
    export type CreateCardAccountMutationBody = CreateCardAccountBody
    export type CreateCardAccountMutationError = AxiosError<unknown>

    export const useCreateCardAccount = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCardAccount>>, TError,{data: CreateCardAccountBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCardAccount>>, {data: CreateCardAccountBody}> = (props) => {
          const {data} = props ?? {};

          return  createCardAccount(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof createCardAccount>>, TError, {data: CreateCardAccountBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Get Card Account Transactions
 * @summary Get Card Account Transactions
 */
export const getCardAccountTransactions = (
    params: GetCardAccountTransactionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetCardAccountTransactions200>> => {
    return axios.get(
      `/cardaccounts/transactions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetCardAccountTransactionsQueryKey = (params: GetCardAccountTransactionsParams,) => [`/cardaccounts/transactions`, ...(params ? [params]: [])];

    
export type GetCardAccountTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getCardAccountTransactions>>>
export type GetCardAccountTransactionsQueryError = AxiosError<unknown>

export const useGetCardAccountTransactions = <TData = Awaited<ReturnType<typeof getCardAccountTransactions>>, TError = AxiosError<unknown>>(
 params: GetCardAccountTransactionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCardAccountTransactions>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCardAccountTransactionsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCardAccountTransactions>>> = ({ signal }) => getCardAccountTransactions(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getCardAccountTransactions>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Transfer balances between two card accounts. This applies to credit card accounts operating in accountType `prepaid`  only'

The source and destination card accounts must be of the same currency and the source card account must have sufficient funds to complete the transfer.

 * @summary Balance Transfer
 */
export const transferCardAccount = (
    transferCardAccountBody: TransferCardAccountBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CardAccountTransaction>> => {
    return axios.post(
      `/cardaccounts/transfer`,
      transferCardAccountBody,options
    );
  }



    export type TransferCardAccountMutationResult = NonNullable<Awaited<ReturnType<typeof transferCardAccount>>>
    export type TransferCardAccountMutationBody = TransferCardAccountBody
    export type TransferCardAccountMutationError = AxiosError<unknown>

    export const useTransferCardAccount = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transferCardAccount>>, TError,{data: TransferCardAccountBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof transferCardAccount>>, {data: TransferCardAccountBody}> = (props) => {
          const {data} = props ?? {};

          return  transferCardAccount(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof transferCardAccount>>, TError, {data: TransferCardAccountBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Top up a card account with funds from an account. This applies to Card accounts of accountType `prepaid`  only
 * @summary Top up account
 */
export const topupCardAccount = (
    topupCardAccountBody: TopupCardAccountBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CardAccountTransaction>> => {
    return axios.post(
      `/cardaccounts/topup`,
      topupCardAccountBody,options
    );
  }



    export type TopupCardAccountMutationResult = NonNullable<Awaited<ReturnType<typeof topupCardAccount>>>
    export type TopupCardAccountMutationBody = TopupCardAccountBody
    export type TopupCardAccountMutationError = AxiosError<TopupCardAccount400>

    export const useTopupCardAccount = <TError = AxiosError<TopupCardAccount400>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof topupCardAccount>>, TError,{data: TopupCardAccountBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof topupCardAccount>>, {data: TopupCardAccountBody}> = (props) => {
          const {data} = props ?? {};

          return  topupCardAccount(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof topupCardAccount>>, TError, {data: TopupCardAccountBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Withdraw card account balance from card account to an account. This applies to Card accounts of accountType `prepaid` only
 * @summary Withdraw card account balance
 */
export const withdrawCardAccount = (
    withdrawCardAccountBody: WithdrawCardAccountBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CardAccountTransaction>> => {
    return axios.post(
      `/cardaccounts/withdraw`,
      withdrawCardAccountBody,options
    );
  }



    export type WithdrawCardAccountMutationResult = NonNullable<Awaited<ReturnType<typeof withdrawCardAccount>>>
    export type WithdrawCardAccountMutationBody = WithdrawCardAccountBody
    export type WithdrawCardAccountMutationError = AxiosError<WithdrawCardAccount400>

    export const useWithdrawCardAccount = <TError = AxiosError<WithdrawCardAccount400>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof withdrawCardAccount>>, TError,{data: WithdrawCardAccountBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof withdrawCardAccount>>, {data: WithdrawCardAccountBody}> = (props) => {
          const {data} = props ?? {};

          return  withdrawCardAccount(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof withdrawCardAccount>>, TError, {data: WithdrawCardAccountBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Simulate repay card account
 * @summary simulate repay card account
 */
export const simulateRepayCardAccount = (
    simulateRepayCardAccountBody: SimulateRepayCardAccountBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SimulateRepayCardAccount200>> => {
    return axios.post(
      `/cardaccounts/simulate-repay`,
      simulateRepayCardAccountBody,options
    );
  }



    export type SimulateRepayCardAccountMutationResult = NonNullable<Awaited<ReturnType<typeof simulateRepayCardAccount>>>
    export type SimulateRepayCardAccountMutationBody = SimulateRepayCardAccountBody
    export type SimulateRepayCardAccountMutationError = AxiosError<unknown>

    export const useSimulateRepayCardAccount = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof simulateRepayCardAccount>>, TError,{data: SimulateRepayCardAccountBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof simulateRepayCardAccount>>, {data: SimulateRepayCardAccountBody}> = (props) => {
          const {data} = props ?? {};

          return  simulateRepayCardAccount(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof simulateRepayCardAccount>>, TError, {data: SimulateRepayCardAccountBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Applicable to card accounts with account type: 'fixed-limit' only.
Adjust the credit limit for one or multiple card accounts.

The request body should contain either a single object or an array of objects, where each object represents a card account with its associated fixed limit.

- For a single card account:
  ```
  {
    "cardAccountId": "string",
    "limit": number
  }
  ```

- For multiple card accounts:
  ```
  [
    {
      "cardAccountId": "string",
      "limit": number
    },
    ...
  ]
  ```

The response will indicate whether the fixed limit was updated successfully or if there was an error.
The sum of all assigned limits must not exceed the credit limit of the loan value of collateral posted for the card program.

 * @summary Adjust limit
 */
export const postCardaccountsFixedLimit = (
    postCardaccountsFixedLimitBody: PostCardaccountsFixedLimitBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/cardaccounts/fixed-limit`,
      postCardaccountsFixedLimitBody,options
    );
  }



    export type PostCardaccountsFixedLimitMutationResult = NonNullable<Awaited<ReturnType<typeof postCardaccountsFixedLimit>>>
    export type PostCardaccountsFixedLimitMutationBody = PostCardaccountsFixedLimitBody
    export type PostCardaccountsFixedLimitMutationError = AxiosError<unknown>

    export const usePostCardaccountsFixedLimit = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCardaccountsFixedLimit>>, TError,{data: PostCardaccountsFixedLimitBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCardaccountsFixedLimit>>, {data: PostCardaccountsFixedLimitBody}> = (props) => {
          const {data} = props ?? {};

          return  postCardaccountsFixedLimit(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postCardaccountsFixedLimit>>, TError, {data: PostCardaccountsFixedLimitBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Update the identity information of a cardholder associated with a specific card account.
 * @summary Update client identity information for a card account
 */
export const postCardaccountsClientIdentity = (
    postCardaccountsClientIdentityBody: PostCardaccountsClientIdentityBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostCardaccountsClientIdentity200>> => {
    return axios.post(
      `/cardaccounts/client-identity`,
      postCardaccountsClientIdentityBody,options
    );
  }



    export type PostCardaccountsClientIdentityMutationResult = NonNullable<Awaited<ReturnType<typeof postCardaccountsClientIdentity>>>
    export type PostCardaccountsClientIdentityMutationBody = PostCardaccountsClientIdentityBody
    export type PostCardaccountsClientIdentityMutationError = AxiosError<unknown>

    export const usePostCardaccountsClientIdentity = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCardaccountsClientIdentity>>, TError,{data: PostCardaccountsClientIdentityBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCardaccountsClientIdentity>>, {data: PostCardaccountsClientIdentityBody}> = (props) => {
          const {data} = props ?? {};

          return  postCardaccountsClientIdentity(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postCardaccountsClientIdentity>>, TError, {data: PostCardaccountsClientIdentityBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Retrieve the identity information of a cardholder associated with a specific card account.
 * @summary Get client identity information for a card account
 */
export const getCardaccountsClientIdentity = (
    params: GetCardaccountsClientIdentityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetCardaccountsClientIdentity200>> => {
    return axios.get(
      `/cardaccounts/client-identity`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetCardaccountsClientIdentityQueryKey = (params: GetCardaccountsClientIdentityParams,) => [`/cardaccounts/client-identity`, ...(params ? [params]: [])];

    
export type GetCardaccountsClientIdentityQueryResult = NonNullable<Awaited<ReturnType<typeof getCardaccountsClientIdentity>>>
export type GetCardaccountsClientIdentityQueryError = AxiosError<unknown>

export const useGetCardaccountsClientIdentity = <TData = Awaited<ReturnType<typeof getCardaccountsClientIdentity>>, TError = AxiosError<unknown>>(
 params: GetCardaccountsClientIdentityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCardaccountsClientIdentity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCardaccountsClientIdentityQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCardaccountsClientIdentity>>> = ({ signal }) => getCardaccountsClientIdentity(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getCardaccountsClientIdentity>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

